import { render } from "./EditIcon.vue?vue&type=template&id=64ae2fa4"
import script from "./EditIcon.vue?vue&type=script&lang=js"
export * from "./EditIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__